import { render, staticRenderFns } from "./RightSide.vue?vue&type=template&id=65745cae&scoped=true"
import script from "./RightSide.vue?vue&type=script&lang=js"
export * from "./RightSide.vue?vue&type=script&lang=js"
import style0 from "./RightSide.vue?vue&type=style&index=0&id=65745cae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65745cae",
  null
  
)

export default component.exports